import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Skill, Experience } from "../types";
import "./Home.css";

const Home: React.FC = () => {
  const skills: Skill[] = [
    { name: "React", category: "development", icon: "⚛️" },
    { name: "TypeScript", category: "development", icon: "📘" },
    { name: "Spring Boot (JAVA, Kotlin)", category: "development", icon: "🍃" },
    { name: "Blockchain", category: "development", icon: "⛓️" },
    { name: "Solidity (SVM)", category: "design", icon: "🔧" },
    { name: "Tact (TVM)", category: "design", icon: "💎" },
    {
      name: "Cloud platforms: AWS, Oracle, Kakao Cloud",
      category: "design",
      icon: "☁️",
    },
    { name: "Docker", category: "design", icon: "🐳" },
  ];

  const experiences: Experience[] = [
    {
      id: "1",
      company: "Kakao Enterprise Academy",
      position: "Backend Developer",
      description:
        "Kakao Work chatbot admin page development with RAG-based improvements",
      startDate: "Mar 2025",
      current: false,
    },
    {
      id: "2",
      company: "UNLV AI Labs",
      position: "Research Assistant",
      description:
        "Academic-Industry Internship in the U.S. - U-Net model fine-tuning",
      startDate: "Dec 2024",
      current: false,
    },
    {
      id: "3",
      company: "CookieLabs",
      position: "BE & Blockchain Dev",
      description: "Jetton tokenomics and TON blockchain project development",
      startDate: "Sep 2023",
      current: false,
    },
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="hero-text">
              <h1>Blockchain & Full-Stack Developer</h1>
              <p>
                I specialize in blockchain and frontend development with React
                and TypeScript, experienced in AI chatbots, community platforms,
                and backend projects with Java and Spring. Passionate about
                bridging technology and community.
              </p>
              <Link to="/contact" className="btn btn-accent">
                Hire me
              </Link>
            </div>
            <div className="hero-image">
              <div className="profile-card">
                <img
                  src={process.env.PUBLIC_URL + "/images/home.png"}
                  alt="이태호"
                  className="profile-img"
                />
                <div className="profile-info">
                  <h3>이태호</h3>
                  <p>dev & community</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* What I Do Section */}
      <section className="section what-i-do">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2>What i do?</h2>
            <div className="skills-grid">
              <div className="skill-category">
                <h3>Blockchain & Smart Contracts</h3>
                <div className="skills-list">
                  {skills
                    .filter((skill) => skill.category === "design")
                    .map((skill, index) => (
                      <div key={index} className="skill-item">
                        <span className="skill-icon">{skill.icon}</span>
                        <span>{skill.name}</span>
                      </div>
                    ))}
                </div>
              </div>
              <div className="skill-category">
                <h3>Full-Stack Development</h3>
                <div className="skills-list">
                  {skills
                    .filter((skill) => skill.category === "development")
                    .map((skill, index) => (
                      <div key={index} className="skill-item">
                        <span className="skill-icon">{skill.icon}</span>
                        <span>{skill.name}</span>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Work Experience */}
      <section className="section work-experience">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2>Work Experience</h2>
            <div className="experience-list">
              {experiences.map((exp, index) => (
                <motion.div
                  key={exp.id}
                  className="experience-item"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <div className="experience-number">{index + 1}</div>
                  <div className="experience-content">
                    <h3>
                      {exp.position} at {exp.company}
                    </h3>
                    <p>{exp.description}</p>
                    <span className="experience-date">{exp.startDate}</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;
